import styled from 'styled-components';
interface propsType {
  minWidth: string;
  children?: JSX.Element | JSX.Element[];
  columnsGap: string;
  rowsGap: string;
}
interface contianerPropsType {
  minWidth: string;
  rowsGap: string;
  columnsGap: string;
}
const AutoColumnsGrid = ({
  minWidth,
  rowsGap,
  columnsGap,
  children
}: propsType) => {
  return (
    <Container
      minWidth={minWidth}
      rowsGap={rowsGap}
      columnsGap={columnsGap}
      data-test="grid-container"
      className="properties-grid"
    >
      {children}
    </Container>
  );
};
const Container = styled.div<contianerPropsType>`
  width: 100%;
  position: relative;
  display: grid;
  grid-template-columns: ${props => `repeat(
    auto-fill,
    minmax(${props.minWidth}, 1fr)
  )`};
  grid-gap: ${props => props.rowsGap} ${props => props.columnsGap};
  @media screen and (max-width: 768px) {
    grid-template-columns: 100%;
  }
`;

export default AutoColumnsGrid;
